import { useQuery } from 'react-query';
import services from 'services/services';
import moment from 'moment';

// Import helpers
import { HAS_BOOKING_IN_RANGE_QUERY } from 'helpers';

const useHasBookingInRange = (enabled, pickupDate, dropDate) => {
	const pickup_date = moment(pickupDate).format('YYYY-MM-DD');
	const drop_date = moment(dropDate).format('YYYY-MM-DD');
	const url = `booking/has-booking-in-range?pickup_date=${pickup_date}&drop_date=${drop_date}`;

	return useQuery(
		[HAS_BOOKING_IN_RANGE_QUERY, pickupDate, dropDate],
		async () => (await services.get(url)).data,
		{
			refetchOnWindowFocus: false,
			enabled
		}
	);
};

export default useHasBookingInRange;
